export {default as BodegaListar} from './Listar'
export {default as BodegaCrear } from './Editar';
